import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const TimeAndBilling = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default TimeAndBilling;
